"use client";

import { VisibleSliceZone } from "@up/ui";

import { components } from "../../slices";

import type { TInventoryItem } from "@up/data";

interface SliceRendererProps {
  prismicData: any[];
  cohortData: TInventoryItem[];
  reusableContentData: any[];
  uid: string;
  isCoursePage?: boolean;
}

export function SliceRenderer({
  prismicData,
  cohortData,
  reusableContentData,
  uid,
  isCoursePage = false,
}: SliceRendererProps) {
  return (
    <VisibleSliceZone
      slices={prismicData}
      components={components}
      context={{ cohortData, reusableContentData, uid, isCoursePage }}
    />
  );
}
